import alfredHomepage from "../../../../src/images/util/alfred_homepage.png";
import alfredInit from "../../../../src/images/util/alfred_init.png";
import alfredSearchApp from "../../../../src/images/util/alfred_search_app.png";
import alfredSearchFile from "../../../../src/images/util/alfred_search_file.png";
import alfredFindFile from "../../../../src/images/util/alfred_find_file.png";
import alfredFindFileEnter from "../../../../src/images/util/alfred_find_file_enter.png";
import alfredSearchUrl from "../../../../src/images/util/alfred_search_url.png";
import alfredCustomWebSearch from "../../../../src/images/util/alfred_custom_web_search.png";
import alfredAddCustomSearch from "../../../../src/images/util/alfred_add_custom_search.png";
import alfredSearchNm from "../../../../src/images/util/alfred_search_nm.png";
import alfredSearchNmResult from "../../../../src/images/util/alfred_search_nm_result.png";
import alfredAddCustomCoupang from "../../../../src/images/util/alfred_add_custom_coupang.png";
import alfredSearchCp from "../../../../src/images/util/alfred_search_cp.png";
import alfredSearchCpResult from "../../../../src/images/util/alfred_search_cp_result.png";
import alfredShutDown from "../../../../src/images/util/alfred_shutdown.png";
import alfredRestart from "../../../../src/images/util/alfred_restart.png";
import alfredQuitAll from "../../../../src/images/util/alfred_quitall.png";
import * as React from 'react';
export default {
  alfredHomepage,
  alfredInit,
  alfredSearchApp,
  alfredSearchFile,
  alfredFindFile,
  alfredFindFileEnter,
  alfredSearchUrl,
  alfredCustomWebSearch,
  alfredAddCustomSearch,
  alfredSearchNm,
  alfredSearchNmResult,
  alfredAddCustomCoupang,
  alfredSearchCp,
  alfredSearchCpResult,
  alfredShutDown,
  alfredRestart,
  alfredQuitAll,
  React
};